import {SisName} from 'util/SisName';
import {VlFehlTO} from 'generated/JavaTO';
import {VlFehl} from 'generated/JavaTOmodifications';

export const getVlErrorCid = (x: VlFehlTO) => `${x.persNr}_${x.datum}_${x.progNr}_${x.nr}`;

export const vlErrorMapper = (d: VlFehlTO): VlFehl => ({
	...d,
	cid: getVlErrorCid(d),
	sisName: SisName.VlFehl,
});